module.exports = __webpack_public_path__ + "img/147_thumbnail.f0aabf0f.jpg";